import React, { Component } from 'react';
import { Formik } from 'formik';
import styled from 'styled-components';
import {
  Input,
  Button,
  Text,
  Title,
  Row,
  Label,
  Column,
  UserWarn,
} from '../../theme/index.js';
import loginButton from '../../../assets/loginButton.svg';
import { RESET_PASSWORD_SUCCESS, resetPassword } from './redux/actions';
import { connect } from 'react-redux';

const Wrapper = styled.div`
  width: 450px;
  height: 365px;
  background: #fff;
  margin-top: 12em;
  position: relative;
  border-radius: 6px;
  @media (max-width: 400px) {
    width: 350px;
  }
`;

const Form = styled.form`
  width: 100%;
`;

const Icon = styled.img`
  width: 40px;
  height: 40px;
`;

const StyledColumn = styled(Column)`
  width: 85%;
  margin: 0 auto;
  @media (max-width: 400px) {
    width: 90%;
  }
`;

class ResetPasswordForm extends Component {
  state = {
    message: false,
    tokenError: null,
  };

  tokenExpired = () => {
    localStorage.clear();
    window.location.href = `https://achievece.com/forgot/password/`;
  };

  render() {
    const { message, tokenError } = this.state;
    return (
      <Wrapper>
        {message && (
          <div>
            <Title margin=".5em 0 .5em .75em">Success!</Title>
            <Text>
              We have successfully sent you an email with password reset
              instructions
            </Text>
          </div>
        )}
        {!message && (
          <React.Fragment>
            <Title margin=".5em 0 .5em .75em">Reset password</Title>
            <Formik
              initialValues={{
                newPassword: '',
                confirmPassword: '',
              }}
              validate={values => {
                let errors = {};

                if (!values.newPassword) {
                  errors.newPassword = 'A new password is required';
                }

                if (!values.confirmPassword) {
                  errors.confirmPassword = 'Required';
                }
                return errors;
              }}
              onSubmit={(values, { setErrors }) => {
                let data = {
                  new_password: values.newPassword,
                };
                this.props.resetPassword(data).then(action => {
                  if (action.type === RESET_PASSWORD_SUCCESS) {
                    this.props.history.push('/login');
                  } else {
                    let message = action.response.data;

                    if (message === 'Token not valid.') {
                      this.setState({
                        tokenError: `Token expired`,
                      });
                    }

                    console.log('error');
                  }
                });
              }}
              render={({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <StyledColumn>
                    {tokenError && (
                      <Row
                        margin=".5em 0"
                        height="25px"
                        width="100%"
                        alignitems="center"
                        onClick={() => this.tokenExpired()}
                      >
                        <Label expired>
                          Token expired, please reset password here
                        </Label>
                      </Row>
                    )}
                    <Column width="100%" margin="0 auto">
                      <Row
                        alignitems="center"
                        margin=".25em 0"
                        style={{ position: 'relative', zIndex: 1000 }}
                      >
                        <Label htmlFor="email" login>
                          New Password *
                          {touched.newPassword && errors.newPassword && (
                            <UserWarn>
                              <Text error>{errors.newPassword}</Text>
                            </UserWarn>
                          )}
                          <Input
                            login
                            margin=".8em 0"
                            type="password"
                            name="newPassword"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.newPassword}
                            border={
                              (touched.newPassword &&
                                errors.newPassword &&
                                '1px solid red') ||
                              (errors.error && '1px solid red')
                            }
                          />
                        </Label>
                      </Row>
                      <Row
                        alignitems="center"
                        margin=".25em 0"
                        style={{ position: 'relative', zIndex: 1000 }}
                      >
                        <Label htmlFor="password" login>
                          Confirm Password *
                          {touched.confirmPassword && errors.confirmPassword && (
                            <UserWarn>
                              <Text error>{errors.confirmPassword}</Text>
                            </UserWarn>
                          )}
                          <Input
                            login
                            type="password"
                            name="confirmPassword"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                            border={
                              (touched.confirmPassword &&
                                errors.confirmPassword &&
                                '1px solid red') ||
                              (errors.error && '1px solid red')
                            }
                          />
                        </Label>
                      </Row>
                    </Column>
                  </StyledColumn>
                  <Button login type="submit">
                    <Icon src={loginButton} />
                  </Button>
                </Form>
              )}
            />
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

export default connect(
  null,
  { resetPassword }
)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/screens/ResetPassword/ResetPasswordForm.jsx